import { render, staticRenderFns } from "./NewsPreviewPopup.vue?vue&type=template&id=4227b6be&lang=html&"
import script from "./NewsPreviewPopup.vue?vue&type=script&lang=js&"
export * from "./NewsPreviewPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewsPreviewPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports